import { IBaseFieldData, IColumnStyle } from './types';

export const getMultiGridSettings = (
  allFields: Record<IBaseFieldData['value'], IBaseFieldData & IColumnStyle>
) =>
  Object.freeze({
    fixedRowCount: 1,
    fixedColumnCount: Object.values(allFields).filter(
      eachField => eachField.isStatic
    ).length,
  });
